import { useQuery } from '@tanstack/react-query'
import { fetchSubscriptionInfo } from '../subscriptions'

export const subscriptionInfoQueryKey = (slug: string) => [slug, 'stripe', 'info'] as const

export const subscriptionInfoQueryOptions = (slug: string) => ({
  queryKey: subscriptionInfoQueryKey(slug),
  queryFn: () => fetchSubscriptionInfo({ slug })
})

export const useSubscriptionInfo = (slug: string) => useQuery(subscriptionInfoQueryOptions(slug))
